import React from 'react';

function AreaAlarmD() {
  return (
    <>
      <style>{`
        .digital-alarm-wrapper {
          padding: 2rem;
          background-color: #f9fbfd;
          font-family: 'Segoe UI', sans-serif;
        }

        .digital-alarm-card {
          max-width: 900px;
          margin: auto;
          background: #fff;
          padding: 2.5rem;
          border-radius: 16px;
          box-shadow: 0 6px 18px rgba(0,0,0,0.08);
        }

        .digital-alarm-card h1 {
          text-align: center;
          font-size: 2.4rem;
          color: #2d3436;
          margin-bottom: 1.8rem;
        }

        .digital-alarm-card img {
          display: block;
          max-width: 100%;
          height: auto;
          margin: 0 auto 2rem;
          border-radius: 10px;
          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.06);
        }

        .digital-alarm-card p {
          font-size: 1.1rem;
          color: #444;
          line-height: 1.6;
          margin-bottom: 1.2rem;
        }

        .digital-alarm-card ul {
          list-style: disc;
          padding-left: 1.8rem;
          font-size: 1.05rem;
          color: #444;
          line-height: 1.6;
        }

        .digital-alarm-card ul li {
          margin-bottom: 0.6rem;
        }

        @media (max-width: 768px) {
          .digital-alarm-wrapper {
            padding: 1rem;
          }

          .digital-alarm-card {
            padding: 1.2rem;
          }

          .digital-alarm-card h1 {
            font-size: 2rem;
          }
        }
      `}</style>

      <main className="digital-alarm-wrapper">
        <section className="digital-alarm-card">
          <h1>Area Alarm (Digital)</h1>
          <img src="aad.png" alt="Area Alarm Digital" />
          <p>Microprocessor Controlled Gas Alarm for different services like Oxygen, N<sub>2</sub>O, Air, Vac, CO<sub>2</sub>, N<sub>2</sub> having the following features:</p>
          <ul>
            <li>Accurate on-line Digital Display of Line Pressure for all the services.</li>
            <li>Factory calibrated imported pressure sensors.</li>
            <li>Colour coded Bar Graph Display (LED) of Line pressure status (High, Caution, Normal, Caution, Low).</li>
            <li>Audible Alarm for High & Low pressure condition.</li>
            <li>Test and Alarm Acknowledge / Mute facility.</li>
            <li>Adjustable Alarm acknowledge time span through program (Password protected).</li>
            <li>Programming facility of (High–Caution–Normal–Caution–Low) Alarm limits for all services from front panel (Password protected).</li>
            <li>Facility to deactivate / activate any of the gas services through front panel programming key (Password protected).</li>
            <li>Facility to connect to remote slave alarm by potential free contacts provided.</li>
          </ul>
        </section>
      </main>
    </>
  );
}

export default AreaAlarmD;
